<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8403,6.4685C20.274,4.0722,18.2131,2.2941,15.75,2.2941
      c-2.2434,0-4.1527,1.4763-4.9044,3.5506c0.3456,0.0278,0.6844,0.0732,1.0164,0.1465c0.6582-1.585,2.1508-2.6974,3.8883-2.6974
      c1.9502,0,3.6426,1.3999,4.1162,3.4048l0.1768,0.7441l0.7637,0.0254c1.2295,0.0405,2.1934,1.0986,2.1934,2.4082
      c0,1.333-1.0146,2.4175-2.2627,2.4175h-0.9351c0.4901,0.2424,0.927,0.5667,1.2916,0.9625C22.7262,13.0681,24,11.6356,24,9.8762
      C24,8.0251,22.5937,6.5268,20.8403,6.4685z"/>
    <path d="M10.2442,6.2941c3.2065,0,5.9841,2.1664,6.7546,5.2684l0.1824,0.7346l0.7565,0.0239
      c2.146,0.0677,3.827,1.7899,3.827,3.9207c0,2.1697-1.7726,3.9348-3.9513,3.9348H3.6993C2.2109,20.1764,1,18.9711,1,17.4894
      c0-1.0995,0.6649-2.0764,1.694-2.4888l0.7008-0.2808l-0.0781-0.751c-0.027-0.2595-0.0402-0.4995-0.0402-0.7336
      C3.2765,9.4079,6.4023,6.2941,10.2442,6.2941 M10.2442,5.2941c-4.4005,0-7.9677,3.5543-7.9677,7.9412
      c0,0.2836,0.017,0.5627,0.0455,0.8372C0.9629,14.6171,0,15.9387,0,17.4894c0,2.0353,1.6561,3.687,3.6992,3.687h14.1141
      c2.7352,0,4.9513-2.2099,4.9513-4.9348c0-2.6729-2.1342-4.8361-4.7954-4.9202C17.1099,7.8614,13.9821,5.2941,10.2442,5.2941
      L10.2442,5.2941z"/>
</g>
</template>

<script>
export default {
  name: 'Cloudy'
}
</script>